import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import Select from "react-select";
import DocumentInfo from "./DocumentInfo";
import { isArray } from "lodash";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [isValidDoc, setisValidDoc] = useState(false);
  const dispatch = useDispatch();
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [pinCodeDetails, setPinCodeDetails] = useState(null);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bankVerfiyJson, setBankVerfiyJson] = useState("");
  const [bankVerificationDone, setBankVerificationDone] = useState(false);
  const [originalBankData, setOriginalBankData] = useState({
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    accountHolderName: "",
  });
  const [banks, setBanks] = useState([]);
  const [securityChequeImages, setSecurityChequeImages] = useState([]);
  const [isSalesPersonsValid, setIsSalesPersonsValid] = useState(true);
  const [isZonesValid, setIsZonesValid] = useState(true);
  const [isDealerDistributorValid, setIsDealerDistributorValid] =
    useState(true);
  const [isTradeVaild, setIsTradeVaild] = useState(true);
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastWord = pathParts[pathParts.length - 1];

  let isAvailableImgAppended = false;
  const [verifiedBankDetails, setVerifiedBankDetails] = useState({
    accountNumber: "",
    ifscCode: "",
  });
  const [bankErrors, setBankErrors] = useState({
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    accountHolderName: "",
  });

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    code: "Auto Generated", // Auto-generated field
    zones: [],
    gstNumber: "",
    authPersonName: "",
    // distributorName: "",
    // dealerName: "",
    type: "",
    channelName: "",
    deposit_amount: "",
    status: "",
    creditLimit: "",
    designation: "",
    mobileNo: "",
    city: "",
    state: "",
    pinCode: "",
    district: "",
    address: "",
    email: "",
    tradeOrNonTrade: [],
    join_date: "",
    salesPersons: [],
    paymentTerms: "",
    customPaymentTerm: "",
    termsAndConditions: "",
    bankName: "",
    accountNumber: "",
    accountHolderName: "",
    ifscCode: "",
    image: [],
    division: "",
    aadharCardNo: "",
    panNo: "",
    adharImage: "",
  });
  const codeLabelMap = {
    distributor: "Distributor Code",
    dealer: "Dealer Code",
    retailer: "Retailer Code",
    "key-accounts": "Key Accounts Code",
    pro: "PRO Code",
  };

  const [nameList, setNameList] = useState([]);
  const [validated, setValidated] = useState(false);
  const multiselectRef = useRef(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [typeCode, setTypeCode] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [isRetailer, setIsRetailer] = useState(false);
  const [distributorsList, setDistributorsList] = useState([]);
  const [dealersList, setDealersList] = useState([]);
  const [isChannelNameValid, setIsChannelNameValid] = useState(true);
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [isEditable, setIsEditable] = useState(false);
  const [divisionLists, setDivisionLists] = useState([]);

  const [dynamicFields, setDynamicFields] = useState([
    { product: "", currency: "", mrp: "", discountedPrice: "", qty: "" },
  ]);

  const allowedFileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  useEffect(() => {
    getProductList();

    // getDealer();
    // getDistributor();
  }, []);

  useEffect(() => {
    if (formData.type !== "") {
      getQuotationList();
    }
  }, [formData.type]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    if (lastWord === "retailer") setIsRetailer(true);
  }, [lastWord]);

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/product-price`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProductList(res);
        } else {
          setProductList([]);
        }
      })
      .catch((err) => {
        setProductList([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
      setEmergencyContactError(validatedValue.length !== 10);
    }

    if (name === "paymentTerms" && value !== "None of Above") {
      setFormData({
        ...formData,
        customPaymentTerm: "",
      });
    }

    if (
      name === "accountNumber" ||
      name === "ifscCode" ||
      name === "bankName" ||
      name === "accountHolderName"
    ) {
      // Clear error for that field
      setBankErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // Update the form data
    const updatedFormData = {
      ...formData,
      [name]: validatedValue,
    };
    setFormData(updatedFormData);

    // Reset verification if any bank field changed
    const bankChanged =
      updatedFormData.accountNumber !== originalBankData.accountNumber ||
      updatedFormData.ifscCode !== originalBankData.ifscCode ||
      updatedFormData.bankName !== originalBankData.bankName ||
      updatedFormData.accountHolderName !== originalBankData.accountHolderName;

    if (bankChanged) {
      setBankVerificationDone(false);
    }

    if (name === "distributorName" || name === "dealerName") {
      setIsDealerDistributorValid(true);
    }
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const validateChannelPartner = () => {
    if (formData.channelName.length === 0) {
      setIsChannelNameValid(false);
      return false;
    }
    setIsChannelNameValid(true);
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isSalesPersonsValid = validateSalesPersons();
    const isZonesValid = validateZones();
    const isDealerDistributorValid = validDealerDistributor();
    const isChannelNameValid = validateChannelPartner();

    const form = e.currentTarget;

    const isBankFieldsFilled =
      formData.bankName ||
      formData.accountNumber ||
      formData.ifscCode ||
      formData.accountHolderName;

    const isBankDataChanged =
      String(formData.bankName || "") !==
        String(originalBankData.bankName || "") ||
      String(formData.accountNumber || "") !==
        String(originalBankData.accountNumber || "") ||
      String(formData.ifscCode || "") !==
        String(originalBankData.ifscCode || "") ||
      String(formData.accountHolderName || "") !==
        String(originalBankData.accountHolderName || "");

    if (
      form.checkValidity() === false ||
      !isSalesPersonsValid ||
      !isZonesValid ||
      (lastWord === "retailer" && !isChannelNameValid)
    ) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (isEdit) {
      if (isBankFieldsFilled) {
        // Changed & not verified ➝ alert
        if (isBankDataChanged && !bankVerificationDone) {
          alert("Please verify your updated bank details before submitting.");
          return;
        }

        // Not changed, but never verified ➝ alert
        // if (!isBankDataChanged && !bankVerificationDone) {
        //   alert("Please verify your bank details before submitting.");
        //   return;
        // }
      }
      // Bank fields are completely empty ➝ skip verification (allowed)
    }

    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();

      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
        bodyFormData.append("client_id", props.rowData.client_id);
      }
      bodyFormData.append("companyName", formData.companyName);
      bodyFormData.append("contactNo", formData.contactPerson);
      bodyFormData.append("code", props.comp === "add" ? "" : formData.code);

      bodyFormData.append("vendor_type", vendorType);
      bodyFormData.append("gst_no", formData.gstNumber);
      bodyFormData.append("deposit_amount", formData.deposit_amount);
      bodyFormData.append("status", formData.status);

      bodyFormData.append(
        "channel_partner_type",
        lastWord === "retailer" ? formData.type : ""
      );
      bodyFormData.append(
        "channel_partner_id",
        lastWord === "retailer" ? formData.channelName : ""
      );

      bodyFormData.append("company_address", formData.address);
      bodyFormData.append("company_state", formData.state);
      bodyFormData.append("company_district", formData.district);
      bodyFormData.append("company_city", formData.city);
      bodyFormData.append("company_pincode", formData.pinCode);
      bodyFormData.append("authorised_person_name", formData.authPersonName);
      bodyFormData.append("authorised_designation", formData.designation);
      bodyFormData.append("authorised_contact_no", formData.mobileNo);
      bodyFormData.append("authorised_email", formData.email);
      bodyFormData.append(
        "joining_date",
        moment(formData.join_date).format("YYYY-MM-DD")
      );
      bodyFormData.append("joining_time", "12:45:00");
      bodyFormData.append(
        "payment_terms",
        formData.paymentTerms === "None of Above"
          ? formData.customPaymentTerm
          : formData.paymentTerms
      );
      bodyFormData.append("credit_limit", formData.creditLimit);
      bodyFormData.append("bank_name", formData.bankName);
      bodyFormData.append("account_no", formData.accountNumber);
      bodyFormData.append("ifsc_code", formData.ifscCode);
      bodyFormData.append("accountHolderName", formData.accountHolderName);
      bodyFormData.append("aadharCardNo", formData.aadharCardNo);
      bodyFormData.append("panCardNo", formData.panNo);
      bodyFormData.append("document", formData.adharImage);

      bodyFormData.append("terms_conditions", formData.termsAndConditions);
      bodyFormData.append("userId", userProfile?.employeeId);
      // bodyFormData.append("aadharCardNo", "");
      // bodyFormData.append("panCardNo", "");
      // bodyFormData.append("verify_json", bankVerfiyJson);
      bodyFormData.append("bank_verify", bankVerificationDone ? "1" : "0");
      bodyFormData.append("division", formData.division);

      // Append zones array
      formData.zones.forEach((zone, index) => {
        bodyFormData.append(`zone[${index}]`, zone);
      });

      //  bodyFormData.append("trade_type", formData.tradeOrNonTrade);

      formData.tradeOrNonTrade.forEach((trade, index) => {
        bodyFormData.append(`trade_type[${index}]`, trade);
      });

      // Append salesPersons array
      formData.salesPersons.forEach((person, index) => {
        bodyFormData.append(`assign_sales_persons[${index}]`, person);
      });

      // Append images
      // formData.image.forEach((img, index) => {
      //   bodyFormData.append(`document[${index}]`, img);
      // });

      formData.image.forEach((img, index) => {
        if (typeof img === "string") {
          bodyFormData.append(`availableImg[${index}]`, img);
        } else {
          if (!img.isDeleted) {
            bodyFormData.append(`document[${index}]`, img);
          }
          // bodyFormData.append(`availableImg[0]`, "");
        }
      });

      const stringImageCount = formData.image.filter(
        (img) => typeof img === "string"
      ).length;

      if (stringImageCount === 0) {
        bodyFormData.append("availableImg[0]", "");
      }
      // bodyFormData.append("availableImg", JSON.stringify(availableImages));

      // Send the request using your preferred method (fetch, axios, etc.)
      utils
        .callAPI("post", "/sales/save_salesform", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const fetchPinCodeDetails = async (pinCode) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pinCode}`
      );
      const data = await response.json();
      if (data && data.length > 0 && data[0].Status === "Success") {
        setPinCodeDetails(data[0].PostOffice[0]);
      } else {
        setPinCodeDetails(null);
      }
    } catch (error) {
      setPinCodeDetails(null);
    }
  };

  useEffect(() => {
    if (formData.pinCode?.length === 6) {
      fetchPinCodeDetails(formData.pinCode);
    } else {
      setPinCodeDetails(null);
    }
  }, [formData.pinCode]);

  useEffect(() => {
    if (pinCodeDetails) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: pinCodeDetails.District,
        state: pinCodeDetails.State,
        country: pinCodeDetails.Country,
      }));
      setIsEditable(false); // Fields are filled correctly, keep them read-only
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: "",
        state: "",
        country: "",
      }));
      setIsEditable(true); // Enable manual entr
    }
  }, [pinCodeDetails]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      if (props?.rowData?.bank_verify == "1") {
        setBankVerificationDone(true);
      } else {
        setBankVerificationDone(false);
      }
      const zonesArray = props?.rowData?.zone.split(",");
      const tradesArray = props?.rowData?.trade_type.split(",");
      const salesArray = props?.rowData?.assign_sales_persons.split(",");
      setisEdit(true);
      setVerifiedBankDetails({
        accountNumber: props.rowData.account_no || "",
        ifscCode: props.rowData.ifsc_code || "",
      });
      //  setTypeCode(props?.trade_type);
      setOriginalBankData({
        bankName: String(props?.rowData?.cl_bankName || ""),
        accountNumber: String(props?.rowData?.cl_accountNumber || ""),
        ifscCode: String(props?.rowData?.cl_ifscCode || ""),
        accountHolderName: props?.rowData?.cl_accountHolderName,
      });

      const predefinedPaymentTerms = [
        "Advance Payment",
        "07 Days",
        "15 Days",
        "30 Days",
        "45 Days",
        "60 Days",
        "90 Days",
        "None of Above",
      ];
      const paymentTermsFromProps = props?.rowData?.payment_terms || "";
      const isCustomPaymentTerm = !predefinedPaymentTerms.includes(
        paymentTermsFromProps
      );

      const bankDetailsPresent =
        props.rowData?.bank_name ||
        props.rowData?.ifsc_code ||
        props.rowData?.account_no;

      setShowBankDetails(bankDetailsPresent);
      setFormData({
        companyName: props?.rowData?.companyName || "",
        contactPerson: props?.rowData?.contactNo || "",
        address: props?.rowData?.company_address || "",
        city: props?.rowData?.company_city || "",
        district: props?.rowData?.company_district || "",
        pinCode: props?.rowData?.company_pincode || "",
        state: props?.rowData?.company_state || "",
        code: props?.rowData?.code || "",
        zones: zonesArray || "",
        gstNumber: props?.rowData?.gst_no || "",
        authPersonName: props?.rowData?.authorised_person_name || "",
        tradeOrNonTrade: tradesArray || [],
        designation: props?.rowData?.authorised_designation || "",
        join_date: new Date(props?.rowData?.joining_date) || "",
        mobileNo: props?.rowData?.authorised_contact_no || "",
        email: props?.rowData?.authorised_email || "",
        paymentTerms: isCustomPaymentTerm
          ? "None of Above"
          : paymentTermsFromProps,
        status: props?.rowData?.status || "",
        customPaymentTerm: isCustomPaymentTerm ? paymentTermsFromProps : "",
        creditLimit: props?.rowData?.credit_limit || "",
        channelName: props?.rowData?.channel_partner_id || "",
        deposit_amount: props?.rowData?.deposit_amount || "",
        division: props?.rowData?.division || "",
        type: props?.rowData?.channel_partner_type || "",
        dealerName: props?.rowData?.dealer_id | "",
        bankName: props?.rowData?.cl_bankName || "",
        accountNumber: String(props?.rowData?.cl_accountNumber || ""),
        accountHolderName: props?.rowData?.cl_accountHolderName,
        ifscCode: String(props?.rowData?.cl_ifscCode || ""),
        termsAndConditions: props?.rowData?.terms_conditions || "",
        image: props.rowData.security_attchment || [],
        salesPersons: salesArray || "",
        adharImage: props?.rowData?.cl_document,
        aadharCardNo: props?.rowData?.cl_aadharCardNo,
        panNo: props?.rowData?.cl_panCardNo || "",
      });

      // setIsBankVerfied(props?.rowData?.bank_verify);
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const isBankDataChanged = () => {
    return (
      formData.bankName !== originalBankData.bankName ||
      formData.accountNumber !== originalBankData.accountNumber ||
      formData.ifscCode !== originalBankData.ifscCode
    );
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      image: [...prevFormData.image, ...validFiles],
    }));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setisValidImage(false);
      return;
    } else {
      setisValidImage(true);
    }
    setFormData({ ...formData, image: [...formData.image, ...validFiles] });
    //setFormData((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleDeleteImage = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prevFormData) => {
          const updatedImages = [...prevFormData.image];
          if (typeof updatedImages[index] === "object") {
            // Handle File object
            updatedImages.splice(index, 1);
          } else if (typeof updatedImages[index] === "string") {
            // Handle URL string
            updatedImages.splice(index, 1); // Simply remove the URL from the array
          }
          return {
            ...prevFormData,
            image: updatedImages,
          };
        });
      }
    });
  };

  const getBankList = () => {
    utils
      .callAPI("get", `/sales/getbankList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setBanks(res);
        } else {
          setBanks([]);
        }
      })
      .catch((err) => {
        setBanks([]);
      });
  };

  const getSalesPersonList = () => {
    utils
      .callAPI("get", `/sales/getSalesPersonList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setSalesPersons(res);
        } else {
          setSalesPersons([]);
        }
      })
      .catch((err) => {
        setSalesPersons([]);
      });
  };

  const getDealer = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", "Dealer");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res.result);
          if (formData.channelName !== "") {
          }
        } else {
          setDistributorsList([]);
        }
      })
      .catch((err) => {
        setDistributorsList([]);
      });
  };

  const getDistributor = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", "Distributor");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDealersList(res.result);
          if (formData.channelName !== "") {
          }
        } else {
          setDealersList([]);
        }
      })
      .catch((err) => {
        setDealersList([]);
      });
  };

  const getQuotationList = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", formData.type);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res.result.companyName);

          setNameList(res.result);
          if (formData.channelName !== "") {
          }
        } else {
          setNameList([]);
        }
      })
      .catch((err) => {
        setNameList([]);
      });
  };
  useEffect(() => {
    getBankList();
    getSalesPersonList();
    getDivisionList();
    //  getTypeCode();
  }, []);

  const getDivisionList = () => {
    utils
      .callAPI("get", `/division/get`)
      .then((res) => {
        if (isArray(res)) {
          setDivisionLists(res);
        } else {
          setDivisionLists([]);
        }
      })
      .catch((err) => {
        setDivisionLists([]);
      });
  };

  const handleZoneMultiSelect = (selectedList, selectedItem) => {
    const zoneIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      zones: zoneIds,
    });
    setIsZonesValid(selectedList?.length > 0);
  };

  const handleZoneRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedZones = formData.zones.filter((id) => id !== removedId);

    setFormData({
      ...formData,
      zones: updatedZones,
    });
    setIsZonesValid(selectedList?.length > 0);
  };

  const handleTradeNonTradeRemove = (selectedList, removedItem) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tradeOrNonTrade: prevFormData.tradeOrNonTrade.filter(
        (item) => item !== removedItem.key
      ),
    }));
    setIsTradeVaild(selectedList?.length > 0);
  };

  const handleTradeNonTradeMultiSelect = (selectedList, selectedItem) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tradeOrNonTrade: [...prevFormData.tradeOrNonTrade, selectedItem.key],
    }));

    setIsTradeVaild(selectedList?.length > 0);
  };

  const handleSalesPersonMultiSelect = (selectedList, selectedItem) => {
    const salesPersonIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      salesPersons: salesPersonIds,
    });
    setIsSalesPersonsValid(selectedList?.length > 0);
  };

  const handleSalesPersonRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedSalesPersons = formData.salesPersons.filter(
      (id) => id !== removedId
    );

    setFormData({
      ...formData,
      salesPersons: updatedSalesPersons,
    });
    setIsSalesPersonsValid(selectedList.length > 0);
  };

  const validateSalesPersons = () => {
    if (formData.salesPersons.length === 0) {
      setIsSalesPersonsValid(false);
      return false;
    }
    setIsSalesPersonsValid(true);
    return true;
  };

  const validateZones = () => {
    if (formData.zones.length === 0) {
      setIsZonesValid(false);
      return false;
    }
    setIsZonesValid(true);
    return true;
  };

  const handleSelect = (selectedList, selectedItem) => {
    const name = "channelName";
    const value =
      selectedList.length > 0 ? selectedList[0].cat : formData.channelName; // Get the ID of the selected item

    setFormData({
      ...formData,
      [name]: value,
    });
    setIsChannelNameValid(selectedList?.length > 0);
    if (multiselectRef.current) {
      multiselectRef.current.select.setValue(value); // Set value again
    }
  };

  const handleRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    // Don't update formData.channelName if there's still a selection
    if (selectedList.length > 0) {
      return; // Early return to avoid unnecessary state update
    }

    // Update formData.channelName to an empty string if no selection left
    setFormData({
      ...formData,
      channelName: "",
    });
    setIsChannelNameValid(selectedList?.length > 0);
  };

  const validDealerDistributor = () => {
    if (formData.dealerName === "" && formData.distributorName === "") {
      setIsDealerDistributorValid(false);
      return false;
    }

    setIsDealerDistributorValid(true);
    return true;
  };

  const handleBankVerify = () => {
    var bodyFormData = new FormData();

    let errors = {
      accountNumber: "",
      ifscCode: "",
      bankName: "",
    };
    let hasError = false;

    if (!formData.accountHolderName) {
      errors.accountHolderName = "Please enter the bank account holder's name.";
      hasError = true;
    }

    if (!formData.accountNumber) {
      errors.accountNumber = "Please enter the bank account number.";
      hasError = true;
    }
    if (!formData.ifscCode) {
      errors.ifscCode = "Please enter the IFSC code.";
      hasError = true;
    }
    if (!formData.bankName) {
      errors.bankName = "Please select a bank.";
      hasError = true;
    }

    setBankErrors(errors);
    // if (!hasError) {
    // }
    // return;
    // bodyFormData.append("ifsc_code", formData.ifscCode);
    // bodyFormData.append("account_no", formData.accountNumber);
    bodyFormData.append("ifsc_code", formData.ifscCode);
    bodyFormData.append("account_no", formData.accountNumber);
    if (isEdit) {
      bodyFormData.append("client_id", props.rowData.client_id);
    }
    if (!hasError) {
      setIsLoading(true);
      // Trigger API call for bank verification
      utils
        .callAPI("post", `/Client/bank-verification-byAdmin`, bodyFormData)
        .then((res) => {
          // If verification is successful, set bank verification state to true
          if (typeof res !== "undefined") {
            if (res.bank_verify) {
              setBankVerificationDone(true);
              setOriginalBankData({
                bankName: formData.bankName,
                accountNumber: formData.accountNumber,
                ifscCode: formData.ifscCode,
                accountHolderName: formData.accountHolderName,
              });
              // setVerifiedBankDetails({
              //   accountNumber: formData.accountNumber,
              //   ifscCode: formData.ifscCode,
              // });
              // setBankVerfiyJson(res.verify_json);
            } else {
              setBankVerificationDone(false);

              // setBankVerfiyJson("");
            }
          }
        })
        .catch((err) => {
          // Handle error if verification fails
        })
        .finally(() => {
          setIsLoading(false); // Stop loading regardless of success or failure
        });
    } else {
      // Show toast notification if both fields are not filled
      //toast.error("Please enter both bank account number and IFSC code.");
    }
  };

  const handleCheckboxChange = (e) => {
    setShowBankDetails(e.target.checked);
  };

  // const filteredZones = isEdit
  //   ? formData.zones.filter((zone) =>
  //       props.rowData.zone.split(",").includes(zone)
  //     )
  //   : [];
  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Add ${vendorType}`}</h4> */}
          <h4>{isEdit ? `Edit` : `Add`}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            {lastWord === "retailer" ? (
              <RB.Row className="mb-4">
                <RB.Col md={6} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Channel Partner"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        name="type"
                        value={formData.type}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Channel Partner...</option>
                        <option value="Dealer">Dealer</option>
                        <option value="Distributor">Distributor</option>
                      </RB.Form.Select>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6} className="no-validation-icon">
                  <div
                    className={
                      formData.channelName === "" ? "mb-3 mt-4" : "mb-3 mt-3"
                    }
                  >
                    <RB.FloatingLabel
                      //label="Channel Partner Name"
                      className="floating-label-fancy"
                    >
                      <Multiselect
                        displayValue="key"
                        onKeyPressFn={function noRefCheck() {}}
                        onRemove={handleRemove}
                        onSearch={function noRefCheck() {}}
                        //onSelect={function noRefCheck() {}}
                        onSelect={(selectedList) => handleSelect(selectedList)}
                        name="channelName"
                        value={formData.channelName}
                        onChange={handleInputChange}
                        // closeOnSelect={formData.channelName !== ""}
                        required
                        selectionLimit={1}
                        options={
                          Array.isArray(nameList)
                            ? nameList.map((name) => ({
                                cat: name.id,
                                key: name.companyName,
                              }))
                            : []
                        }
                        selectedValues={
                          formData.channelName && Array.isArray(nameList)
                            ? nameList
                                .filter(
                                  (name) => name.id === formData.channelName
                                )
                                .map((name) => ({
                                  cat: name.id,
                                  key: name.companyName,
                                }))
                            : []
                        }
                        placeholder="Channel Partner Name..."
                        customCloseIcon={
                          <>
                            <i className="material-icons-outlined md14 ms-1">
                              cancel
                            </i>
                          </>
                        }
                        style={{
                          chips: {
                            background: "#FFDE1B",
                            color: "#000000",
                            borderRadius: "1rem",
                            cursor: "pointer",
                          },
                          multiselectContainer: {
                            zIndex: 10,
                          },
                          searchBox: {
                            border: "none",
                            borderBottom: "1px solid #dee2e6",
                            borderRadius: "0px",
                          },
                        }}
                        // placeholder="Select Channel Partner Name..."
                      />
                      {!isChannelNameValid && (
                        <div className="text-danger mt-1">
                          Please select at least one Channel Partner Name.
                        </div>
                      )}
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
            ) : (
              // <RB.Row className="mb-4">
              //   <RB.Col md={6}>
              //     <div className="">
              //       <RB.FloatingLabel
              //         label="Distributor Name"
              //         className="floating-label-fancy"
              //       >
              //         <RB.Form.Select
              //           name="distributorName"
              //           value={formData.distributorName}
              //           onChange={handleInputChange}
              //           required={formData.dealerName === ""}
              //         >
              //           <option value={""}>Select Distributor</option>
              //           {distributorsList &&
              //             distributorsList.map((item, i) => (
              //               <option
              //                 key={i}
              //                 value={item.id}
              //               >{`${item.companyName}`}</option>
              //             ))}
              //         </RB.Form.Select>
              //       </RB.FloatingLabel>
              //     </div>
              //   </RB.Col>

              //   <RB.Col md={6}>
              //     <div className="">
              //       <RB.FloatingLabel
              //         label="Dealer Name"
              //         className="floating-label-fancy"
              //       >
              //         <RB.Form.Select
              //           name="dealerName"
              //           value={formData.dealerName}
              //           onChange={handleInputChange}
              //           required={formData.distributorName === ""}
              //         >
              //           <option value={""}>Select Dealer</option>
              //           {dealersList &&
              //             dealersList.map((item, i) => (
              //               <option
              //                 key={i}
              //                 value={item.id}
              //               >{`${item.companyName}`}</option>
              //             ))}
              //         </RB.Form.Select>
              //       </RB.FloatingLabel>
              //     </div>
              //   </RB.Col>

              //   {!isDealerDistributorValid && (
              //     <div className="text-danger mt-1">
              //       Please select any of the Distributor or Dealer.
              //     </div>
              //   )}
              // </RB.Row>
              ""
            )}
            <h6>Basic Information</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3 ">
                  <RB.FloatingLabel
                    label="Company Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Company Name"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      required
                      // maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Contact Person"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Contact Person"
                      name="contactPerson"
                      value={formData.contactPerson}
                      onChange={handleInputChange}
                      required
                      // maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="GST Number"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter GST Number"
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleInputChange}
                      maxLength={15}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label={codeLabelMap[props.currentComp]}
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="code"
                      value={
                        props.comp === "add" ? "Auto Generated" : formData.code
                      }
                      readOnly
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3 mt-4">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <Multiselect
                      name="zones"
                      displayValue="key"
                      id="zone_multiselect"
                      onKeyPressFn={function noRefCheck() {}}
                      onRemove={handleZoneRemove}
                      onSearch={function noRefCheck() {}}
                      onSelect={handleZoneMultiSelect}
                      options={[
                        { cat: "South", key: "South" },
                        { cat: "West", key: "West" },
                        { cat: "East", key: "East" },
                        { cat: "Central", key: "Central" },
                        { cat: "North", key: "North" },
                      ]}
                      selectedValues={
                        Array.isArray(formData.zones)
                          ? formData.zones.map((zone) => ({
                              cat: zone,
                              key: zone,
                            }))
                          : []
                      }
                      placeholder="Select Zones.."
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                    />

                    {!isZonesValid && (
                      <div className="text-danger mt-1">
                        Please select at least one Zone.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3 mt-4">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <Multiselect
                      name="tradeOrNonTrade"
                      displayValue="key"
                      id="trade_non_trade_multiselect"
                      onKeyPressFn={function noRefCheck() {}}
                      onRemove={handleTradeNonTradeRemove}
                      onSearch={function noRefCheck() {}}
                      onSelect={handleTradeNonTradeMultiSelect}
                      options={[
                        {
                          cat: "Trade",
                          key: "Trade (Retail Pack)",
                        },
                        {
                          cat: "Non-Trade",
                          key: "Non-Trade (Project Pack)",
                        },
                      ]}
                      selectedValues={formData.tradeOrNonTrade.map(
                        (option) => ({
                          cat: option,
                          key: option,
                        })
                      )}
                      placeholder="Trade or Non-Trade.."
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                    />
                    {!isTradeVaild && (
                      <div className="text-danger mt-1">
                        Please select at least one option.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Contact Details</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Authorised Person Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Authorised Person Name"
                      name="authPersonName"
                      value={formData.authPersonName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Designation"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Designation"
                      name="designation"
                      value={formData.designation}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Mobile No"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Mobile No"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                      required
                      maxLength={10}
                    />
                    {emergencyContactError ? (
                      <span className="text-danger">
                        {" "}
                        Please provide a valid Mobile Number.
                      </span>
                    ) : (
                      ""
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Email"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <h6>Registration Office </h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Address"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Address "
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Pin Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Pin Code "
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleInputChange}
                      maxLength={6}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="City"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter City"
                      name="city"
                      value={formData.city}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value)) {
                          handleInputChange(e); // only call if value has valid chars
                        }
                      }}
                      readOnly={!isEditable}
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="State"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      value={formData.state}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      maxLength={32}
                      readOnly={!isEditable}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="District"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter District"
                      name="district"
                      value={formData.district}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6}>
                <h6>Joining Date</h6>
                <hr className="mb-1" />
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    // label="Join Date"
                    className="floating-label-fancy"
                  >
                    <DatePicker
                      selected={formData.join_date}
                      onChange={(date) =>
                        setFormData({ ...formData, join_date: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select Join Date"
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <h6 className="mb-0">Division</h6>
                <div className="mb-3">
                  <RB.FloatingLabel
                    // label="Division"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="division"
                      value={formData.division}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Division...</option>
                      {Array.isArray(divisionLists) &&
                        divisionLists.map((division) => (
                          <option key={division.id} value={division.id}>
                            {division.division_name}
                          </option>
                        ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Payment Terms</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Payment Terms"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="paymentTerms"
                      value={formData.paymentTerms}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Payment Terms...</option>
                      <option value="Advance Payment">Advance Payment</option>
                      <option value="07 Days">07 Days</option>
                      <option value="15 Days">15 Days</option>
                      <option value="30 Days">30 Days</option>
                      <option value="45 Days">45 Days</option>
                      <option value="60 Days">60 Days</option>
                      <option value="90 Days">90 Days</option>
                      <option value="None of Above">None of Above</option>
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              {formData.paymentTerms === "None of Above" && (
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Enter Payment Term"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Custom Payment Term"
                        name="customPaymentTerm"
                        value={formData.customPaymentTerm}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              )}
            </RB.Row>
            <h6>Credit Limit</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Credit Limit"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Credit Limit"
                      name="creditLimit"
                      value={formData.creditLimit}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Deposit Amount</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Deposit Amount"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Deposit Amount"
                      name="deposit_amount"
                      value={formData.deposit_amount}
                      onChange={handleInputChange}
                      // required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Bank Details</h6>
            <hr className="mb-1" />
            {/* <RB.Row>
              <RB.Col md={12}>
                <div className="mb-3">
                  <RB.Form.Check
                    type="checkbox"
                    label="Do you have bank details?"
                    checked={showBankDetails}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </RB.Col>
            </RB.Row> */}

            {/* {showBankDetails && (
              <> */}
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Account Holder's Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Account Holder's Name"
                      name="accountHolderName"
                      value={formData.accountHolderName}
                      onChange={handleInputChange}
                    />
                    {bankErrors.accountHolderName && (
                      <span className="text-danger">
                        {bankErrors.accountHolderName}
                      </span>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Name of Bank"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="bankName"
                      value={formData.bankName}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Bank...</option>
                      {banks?.map((bank, index) => (
                        <option key={index} value={bank.bankName}>
                          {bank.bankName}
                        </option>
                      ))}
                    </RB.Form.Select>
                    {bankErrors.bankName && (
                      <span className="text-danger">{bankErrors.bankName}</span>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              {/* Account Number, IFSC, and Bank Verify in same row */}
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Account Number"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Account Number"
                      name="accountNumber"
                      value={formData.accountNumber}
                      onChange={handleInputChange}
                    />
                    {bankErrors.accountNumber && (
                      <span className="text-danger">
                        {bankErrors.accountNumber}
                      </span>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="IFSC Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter IFSC Code"
                      name="ifscCode"
                      value={formData.ifscCode}
                      onChange={handleInputChange}
                    />
                    {bankErrors.ifscCode && (
                      <span className="text-danger">{bankErrors.ifscCode}</span>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              {isEdit && (
                <RB.Col
                  md={2}
                  className="d-flex align-items-center mt-2 mt-md-0"
                >
                  <RB.Button onClick={handleBankVerify} className="w-100">
                    Bank-Verify
                  </RB.Button>
                </RB.Col>
              )}
            </RB.Row>

            <DocumentInfo formData={formData} setFormData={setFormData} />

            <RB.Row>
              <RB.Col md={12}>
                <h6 className="mb-1 small">Security Cheque</h6>
                <hr />

                <RB.Row className="mt-3 g-3 mb-3">
                  {formData.image.map((file, index) => {
                    const isString = typeof file === "string";
                    const fileUrl = isString ? file : URL.createObjectURL(file);
                    const fileName = isString ? file : file.name;

                    // Check file extension
                    const extension = fileName.split(".").pop().toLowerCase();
                    const isImage = ["jpg", "jpeg", "png"].includes(extension);

                    return (
                      <RB.Col className="col-md-6 col-lg-4" key={index}>
                        <div className="position-relative mb-4">
                          <div className="document-image text-center">
                            {isImage ? (
                              <img
                                src={fileUrl}
                                alt={`Attachment ${index + 1}`}
                                className="img-fluid"
                                style={{
                                  maxHeight: "200px",
                                  objectFit: "contain",
                                }}
                              />
                            ) : (
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <div
                                  style={{
                                    padding: "20px",
                                    border: "1px dashed #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  <i
                                    className="material-icons-outlined"
                                    style={{ fontSize: "36px" }}
                                  >
                                    description
                                  </i>
                                  <div className="mt-2 small">
                                    📎 {extension.toUpperCase()} File
                                  </div>
                                </div>
                              </a>
                            )}
                          </div>
                          <RB.Button
                            variant="danger"
                            className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                            onClick={() => handleDeleteImage(index)}
                          >
                            <i className="material-icons-outlined">delete</i>
                          </RB.Button>
                        </div>
                      </RB.Col>
                    );
                  })}

                  <RB.Col className="col-md-6 col-lg-4">
                    <div
                      className={`border p-4 text-center d-flex flex-column align-items-center ${
                        isDraggingOver ? "bg-info" : ""
                      }`}
                      onDragOver={(e) => handleDragOver(e, "image")}
                      onDragEnter={(e) => handleDragEnter(e, "image")}
                      onDragLeave={(e) => handleDragLeave(e, "image")}
                      onDrop={(e) => handleDrop(e, "image")}
                    >
                      <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                        <i className="material-icons-outlined">cloud_upload</i>
                      </div>
                      <p className="mb-0">Drag & Drop your images here</p>
                      <small className="mb-2">or</small>
                      <div>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                          id="securityChequeInput"
                        />
                        <RB.Button
                          variant="primary"
                          className="me-2"
                          onClick={() =>
                            document
                              .getElementById("securityChequeInput")
                              .click()
                          }
                        >
                          <i className="las la-file-upload me-1"></i>Browse
                          Images
                        </RB.Button>
                      </div>
                    </div>
                    <span className={`${isValidImage ? "text-danger" : ""}`}>
                      <small>
                        *Note: Only JPG, JPEG, PNG, PDF, Word, and Excel files
                        are allowed
                      </small>
                    </span>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>
            {/* </>
            )} */}

            <h6>Terms and Conditions</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={12}>
                <div className="mb-3 mt-3">
                  <ReactQuill
                    theme="snow"
                    className="custom-quill"
                    value={formData.termsAndConditions}
                    onChange={(content) =>
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        termsAndConditions: content,
                      }))
                    }
                    placeholder="Enter Terms and Conditions"
                    required
                  />
                </div>
              </RB.Col>
            </RB.Row>

            {/* <h6>Assign Sales Person</h6>
            <RB.Row>
              <RB.Col md={12}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <Multiselect
                      name="salesPersons"
                      displayValue="key"
                      id="sales_person_multiselect"
                      onKeyPressFn={function noRefCheck() {}}
                      onRemove={handleSalesPersonRemove}
                      onSearch={function noRefCheck() {}}
                      onSelect={handleSalesPersonMultiSelect}
                      options={
                        Array.isArray(salesPersons)
                          ? salesPersons.map((person) => ({
                              cat: `${person.firstName} ${person.lastName}`, // Change to person.id for uniqueness
                              key: `${person.firstName} ${person.lastName}`,
                            }))
                          : []
                      }
                      selectedValues={
                        Array.isArray(formData.salesPersons)
                          ? formData.salesPersons.map((salePerson) => ({
                              cat: salePerson,
                              key: salePerson,
                            }))
                          : []
                      }
                      // selectedValues={
                      //   isEdit
                      //     ? salesPersons
                      //         .filter((plan) =>
                      //           props?.rowData?.assign_sales_persons
                      //             .split(",")
                      //             .includes(plan.id.toString())
                      //         )
                      //         .map((plan) => ({ cat: plan.id, key: plan.name }))
                      //     : ""
                      // }
                      placeholder="Select Sales Persons.."
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                    />
                    {!isSalesPersonsValid && (
                      <div className="text-danger mt-1">
                        Please select at least one sales person.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row> */}

            <h6>Assign Sales Person</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={12}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <Select
                      isMulti
                      options={
                        Array.isArray(salesPersons)
                          ? salesPersons.map((person) => ({
                              value: String(person.id),
                              label: `${person.firstName} ${person.lastName}`,
                            }))
                          : []
                      }
                      // ─── show what’s currently selected by matching ids
                      value={
                        Array.isArray(formData.salesPersons)
                          ? salesPersons
                              .map((person) => ({
                                value: String(person.id),
                                label: `${person.firstName} ${person.lastName}`,
                              }))
                              .filter((opt) =>
                                formData.salesPersons.includes(opt.value)
                              )
                          : []
                      }
                      className="bom-productName-select"
                      // ─── when user selects/removes, you get an array of selected options
                      onChange={(selectedOptions) => {
                        const ids = (selectedOptions || []).map(
                          (opt) => opt.value
                        );
                        setFormData({ ...formData, salesPersons: ids });
                        setIsSalesPersonsValid(ids.length > 0);
                      }}
                      // ─── keep the menu open for multiple pick
                      closeMenuOnSelect={false}
                      // ─── placeholder & styling
                      placeholder="Select Sales Persons..."
                      classNamePrefix={
                        isSalesPersonsValid ? "" : "react-select-invalid"
                      }
                    />

                    {!isSalesPersonsValid && (
                      <div className="text-danger mt-1">
                        Please select at least one sales person.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Status</h6>
            <hr className="mb-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Status"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Status...</option>
                      <option value="1">Active</option>
                      <option value="0">In-Active</option>
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              {formData.paymentTerms === "None of Above" && (
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Enter Payment Term"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Custom Payment Term"
                        name="customPaymentTerm"
                        value={formData.customPaymentTerm}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              )}
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button
                  variant="primary"
                  type="submit"
                  // disabled={!bankVerificationDone}
                >
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
